import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { BROADCAST_TYPES } from '../../utils/constants';
import { getSlotSpan } from '../../utils/helpers';

export function ShowCard({
  entry,
  show,
  canEdit,
  onEdit,
  onDelete,
  isDragging,
  visibleSpan,
  isOverflow,
}) {
  const duration = entry?.duration ?? show?.default_duration ?? 30;
  const slotSpan = visibleSpan || getSlotSpan(duration);
  const spanClass = slotSpan > 1 ? `show-card-span-${Math.min(slotSpan, 6)}` : '';

  const broadcastType = BROADCAST_TYPES.find(
    (t) => t.value === (entry?.broadcast_type ?? show?.broadcast_type)
  );
  const bgColor = show?.color || '#607D8B';

  const dragId = isOverflow ? `overflow-${entry.id}` : String(entry.id);
  const { attributes, listeners, setNodeRef } = useDraggable({
    id: dragId,
    data: { entry, show },
    disabled: !canEdit || isOverflow,
  });

  const handleClick = () => {
    if (canEdit && onEdit) {
      onEdit(entry);
    }
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (canEdit && onDelete) {
      onDelete(entry.id);
    }
  };

  let episodeStr = '';
  if (entry?.season && entry?.episode) {
    episodeStr = `S${entry.season} E${entry.episode}`;
  }
  if (entry?.episode_title && slotSpan >= 2) {
    episodeStr = episodeStr ? `${episodeStr} - ${entry.episode_title}` : entry.episode_title;
  }

  return (
    <div
      ref={setNodeRef}
      className={`show-card ${spanClass} ${isOverflow ? 'overflow-card' : ''} ${isDragging ? 'dragging' : ''} ${!canEdit ? 'read-only' : ''}`}
      style={{ backgroundColor: bgColor }}
      onClick={handleClick}
      {...(canEdit && !isOverflow ? { ...attributes, ...listeners } : {})}
    >
      {canEdit && !isOverflow && (
        <div className="show-card-actions">
          <button
            type="button"
            className="show-card-delete"
            onClick={handleDelete}
            aria-label="Supprimer"
          >
            ×
          </button>
        </div>
      )}
      <span className="show-card-name" title={show?.name}>
        {isOverflow ? `${show?.name} (suite)` : show?.name}
      </span>
      {!isOverflow && broadcastType && broadcastType.value !== 'rerun' && (
        <span
          className="show-card-badge"
          style={{ backgroundColor: broadcastType.color }}
        >
          {broadcastType.label}
        </span>
      )}
      {!isOverflow && episodeStr && (
        <span className="show-card-episode">{episodeStr}</span>
      )}
      {canEdit && !isOverflow && <span className="show-card-drag-handle">⋮⋮</span>}
    </div>
  );
}
